import { differenceInCalendarDays } from "date-fns";

/**
 *
 * @param cprNumber 4 digits, reprecenting cpr-number
 * @param birthDate birthdate, in string format
 * @returns boolean Whether or not data matches cpr number, accoring to https://da.wikipedia.org/wiki/CPR-nummer#Hvordan_personnumre_tildeles
 */
export function cprMatchesBirthdate(
  cprNumber: string | undefined,
  birthDate: string,
) {
  if (!birthDate) return true;
  if (!cprNumber) return true;
  const foedselsDato = new Date(birthDate);
  const foedselsAar = foedselsDato.getFullYear();
  const ciffer7 = cprNumber[0];
  if (["0", "1", "2", "3"].indexOf(ciffer7) > -1) {
    // 1900-1999
    return foedselsAar > 1899 && foedselsAar < 2000;
  }
  if (["4", "9"].indexOf(ciffer7) > -1) {
    // 2000-2036, 1937-1999
    return foedselsAar > 1936 && foedselsAar < 2037;
  }
  if (["5", "6", "7", "8"].indexOf(ciffer7) > -1) {
    //2000-2057, 1858-1899
    return (
      (foedselsAar > 1857 && foedselsAar < 1900) ||
      (foedselsAar > 1999 && foedselsAar < 2058)
    );
  }
  return true;
}

/**
 *
 * @param predicate Predicate, if true, input must be truthy
 * @param input
 * @returns boolean
 */
export function requiredIfPredicate(predicate: boolean, input: any) {
  if (predicate) return !!input;
  return true;
}

export function validateTilKlDagEfterFraKlDag(
  fraDato: Date | undefined | null,
  tilDato: Date | undefined | null,
  fraKlDag: Date | undefined | null,
  tilKlDag: Date | undefined | null,
) {
  if (fraDato && tilDato && fraKlDag && tilKlDag) {
    if (differenceInCalendarDays(fraDato, tilDato) < 0) return true;
    if (differenceInCalendarDays(fraDato, tilDato) > 0) return false;
    return fraKlDag.getTime() < tilKlDag.getTime();
  }
  return true;
}

export function validateTilDatoEfterEllerSammeSomFraDato(
  fraDato: Date | undefined | null,
  tilDato: Date | undefined | null,
) {
  if (fraDato && tilDato) {
    return differenceInCalendarDays(fraDato, tilDato) < 1;
  }
  return true;
}

export const containsOnlyWhitespace = (val: string | undefined) => {
  if (!val) return false;
  return /^\s+$/.test(val);
};

export const validateEmail = (email: string) => {
  return /^[\w-.]+@([\w-]+\.)+[\w-]{2,63}$/.test(email);
  // return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
